export default "__VITE_PUBLIC_ASSET__acda79be__"